module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg01.4f41ea0e.jpg";